/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo, MouseEventHandler} from 'react';
import {Checkbox} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {dlsAlt, dlsColor} from '../theme/theme';

const useCheckboxStyles = makeStyles(() => ({
  gridHeaderCheckbox : {
    padding    : 0,
    marginLeft : '-4px',
    '& svg'    : {
      fontSize : '1.34rem',
      color    : dlsAlt('components', 'checkBox', 'borderColor')
    }
  },
  checked : {
    '&.Mui-checked' : {
      '& svg' : {
        color : dlsColor('caBlue')
      },
      '&:hover' : {
        backgroundColor : 'transparent'
      }
    },
    '&:hover' : {
      backgroundColor : 'transparent'
    }
  }
}));

interface CheckboxProps {
  checked: boolean;
  indeterminate: boolean;
  onClick?: MouseEventHandler;
}

/**
 * Ion styled checkbox built for re-use.
 *
 * ```typescript
 *
 *  import {IonCheckbox} from '@ion/dls/src/grid/';
 *
 *  <IonCheckbox onClick={onClick}
 *    checked={true}
 *    indeterminate={false} />
 *
 * ```
 */
export const IonCheckbox = ({
  onClick,
  checked,
  indeterminate
}: CheckboxProps) => {
  const classes = useCheckboxStyles();

  return (
    <Checkbox disableRipple
      onClick={onClick}
      size='small'
      checked={checked}
      indeterminate={indeterminate}
      classes={{
        root           : classes.gridHeaderCheckbox,
        colorSecondary : classes.checked
      }} />
  );
};

export default memo(IonCheckbox);
